export const tr = {
  // Navigation
  documentList: 'Belge Listesi',
  uploadDocument: 'Belge Yükle',
  contactUs: 'Bize Ulaşın',
  profile: 'Profil',
  login: 'Giriş',
  logout: 'Çıkış',
  aboutUs: 'Hakkımızda',
  apiReference: 'API Referansı',
  integration: 'Entegrasyon',
  navWorkspace: 'Çalışma alanı',
  navResources: 'Kaynaklar',
  navAccount: 'Hesap',
  navBackToDocuments: 'Belgelere dön',
  menu: 'Menü',

  // Common
  version: 'Sürüm',
  language: 'Dil',

  // Upload Document
  stepSelectOrganisation: 'Kuruluşu seçin',
  step2: 'İmzacılar',
  step3: 'Belge Bilgisi',
  step4: 'Yükle',
  documentTitle: 'Belge Başlığı',
  moreDocumentDetails: 'Diğer bilgiler',
  hideDocumentDetails: 'Bilgileri gizle',
  uploadOperationIdLabel: 'İşlem / referans no.',
  uploadOperationIdPlaceholder: 'örn. sözleşme no., sipariş no.',
  uploadOperationIdHint: 'İsteğe bağlı. Bu imza talebi için dahili referansınız.',
  description: 'Açıklama',
  expireDate: 'Son Geçerlilik Tarihi',
  summary: 'Özet',
  addSigner: 'İmzacı Ekle',
  addMeAsSigner: 'Beni imzacı olarak ekle',
  alreadyAddedAsSigner: 'Zaten imzacılar listesindesiniz.',
  addMeAsSignerNoEmail: 'Profilinizde e-posta adresi yok.',
  addMeAsSignerPromo: 'Yalnız kendiniz mi imzalıyorsunuz? Bilgilerinizi tek dokunuşla doldurun.',
  uploadStepValidationIntro: 'Devam etmek için vurgulanan alanları doldurun.',
  uploadSignerOptionalSection: 'İletişim ve kimlik (isteğe bağlı)',
  uploadFinOptionalHint: 'Gerek yoksa FIN boş bırakın. Doldurursanız 7 karakter olmalıdır.',
  uploadMoreSignerTin: 'VÖEN',
  uploadHideSignerTin: 'VÖEN alanını gizle',
  uploadTinOptionalHint: 'İsteğe bağlı. Doldurursanız VÖEN 10 rakam olmalıdır.',
  uploadUnsavedLeaveWarning: 'Kaydedilmemiş yükleme ilerlemeniz var. Sayfadan ayrılmak istiyor musunuz?',
  uploadOptionalSuffix: 'isteğe bağlı',
  signerLabel: 'İmzacı',
  signerName: 'Ad',
  signerSurname: 'Soyad',
  signerEmail: 'E-posta',
  signerPhone: 'Telefon',
  signerRole: 'Rol',
  roleSigner: 'İmzacı',
  roleVisa: 'Vize',
  delete: 'Sil',
  next: 'İleri',
  back: 'Geri',
  submit: 'Gönder',
  cancel: 'İptal',

  // Document List
  documents: 'Belgeler',
  noDocuments: 'Belge yok',

  // Profile
  profileTitle: 'Profil',
  name: 'Ad',
  surname: 'Soyad',
  email: 'E-posta',
  phone: 'Telefon',
  save: 'Kaydet',

  // Login/Register
  emailLabel: 'E-posta',
  password: 'Şifre',
  rememberMe: 'Beni hatırla',
  forgotPassword: 'Şifrenizi mi unuttunuz?',
  username: 'Kullanıcı adı',
  usernameRequired: 'Kullanıcı adı zorunludur',
  invalidUsernameFormat: '2–64 karakter: harf, rakam, nokta, alt çizgi veya tire',
  usernameHelper: 'Sadece harf, rakam, . _ -',
  register: 'Kayıt Ol',
  alreadyHaveAccount: 'Zaten hesabın var mı?',
  dontHaveAccount: 'Hesabın yok mu?',

  // Errors and Messages
  required: 'Bu alan zorunludur',
  invalidEmail: 'Geçersiz e-posta adresi',
  invalidPhone: 'Geçersiz telefon numarası',
  nameRequired: 'Ad zorunludur',
  surnameRequired: 'Soyad zorunludur',
  emailRequired: 'E-posta zorunludur',
  passwordRequired: 'Şifre zorunludur',
  finRequired: 'FIN kodu zorunludur',
  phoneRequired: 'Telefon numarası zorunludur',
  titleRequired: 'Başlık zorunludur',
  expireDateRequired: 'Son geçerlilik tarihi zorunludur',
  invalidEmailFormat: 'Geçersiz e-posta formatı',
  invalidPhoneFormat: 'Geçersiz telefon numarası formatı',
  invalidPhoneLength: 'Geçersiz telefon numarası (rakamlar, isteğe bağlı +, uzunluk 7-15)',
  passwordMinLength: 'Şifre en az 6 karakter olmalı',
  passwordsDoNotMatch: 'Şifreler eşleşmiyor',
  finCodeLength: 'FIN kodu 7 karakter olmalı',
  tinCodeLength: 'VÖEN kodu 10 rakam olmalı',
  selectOrganisation: 'Lütfen bir kuruluş seçin',
  addAtLeastOneSigner: 'Lütfen en az bir imzacı ekleyin',
  selectFile: 'Lütfen yüklemek için bir PDF dosyası seçin.',
  selectPdfFile: 'Yalnızca PDF dosyalarına izin verilir. Lütfen bir PDF dosyası seçin.',
  organisationNotSelected: 'Kuruluş seçilmedi. Lütfen geri dönüp bir kuruluş seçin.',
  uploadFailed: 'Belgeyi yükleme ve gönderme başarısız oldu. Lütfen tekrar deneyin.',
  loginFailed: 'Giriş başarısız oldu. Lütfen tekrar deneyin.',  uploadInProgress: 'Yükleme devam ediyor...',
  uploadInProgressHint: 'Belge yüklenip gönderim tamamlanana kadar lütfen bekleyin.',
  uploading: 'Yükleniyor...',

  registrationFailed: 'Kayıt başarısız oldu. Lütfen tekrar deneyin.',

  // Login/Register Extended
  signIn: 'Giriş Yap',
  signUp: 'Kayıt Ol',
  signingIn: 'Giriş yapılıyor...',
  creatingAccount: 'Hesap oluşturuluyor...',
  signInToAccount: 'mySign.az hesabınıza giriş yapın',
  createAccount: 'mySign.az hesabınızı oluşturun',
  keepMeLoggedIn: 'Beni oturum açık tut',
  emailAddress: 'E-posta Adresi',
  confirmPassword: 'Şifreyi Onayla',
  phoneNumber: 'Telefon Numarası',
  finCode: 'FIN Kodu',
  finCodeHelper: '7 karakter',

  recoverPasswordTitle: 'Şifre kurtarma',
  recoverPasswordDescription: 'E-postanızı girin; sıfırlama bağlantısı göndereceğiz.',
  sendResetLink: 'Sıfırlama bağlantısı gönder',
  sendingResetLink: 'Gönderiliyor…',
  resetEmailSent:
    'Bu adres için bir hesap varsa kısa süre içinde talimatları alırsınız. Gelen kutunuzu kontrol edin.',
  resetPasswordTitle: 'Yeni şifre',
  resetPasswordDescription: 'Hesabınız için yeni bir şifre seçin.',
  newPassword: 'Yeni şifre',
  setNewPassword: 'Şifreyi güncelle',
  updatingPassword: 'Güncelleniyor…',
  backToSignIn: 'Girişe dön',
  invalidResetLink: 'Bu sıfırlama bağlantısı geçersiz veya eksik. Yeni bir bağlantı isteyin.',
  passwordResetSuccess: 'Şifreniz güncellendi. Giriş yapabilirsiniz.',
  passwordResetFailed: 'Şifre sıfırlanamadı. Bağlantının süresi dolmuş olabilir.',
  requestPasswordResetFailed: 'Sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin.',
  
  confirmEmailTitle: 'E-posta onayı',
  confirmingEmail: 'E-postanız onaylanıyor...',
  confirmEmailSuccess: 'E-postanızı onayladığınız için teşekkürler. Artık giriş yapabilirsiniz.',
  confirmEmailSuccessHint: 'E-postanız onaylandı. Giriş sayfasına yönlendiriliyorsunuz...',
  confirmEmailFailed: 'E-posta onaylanamadı. Bağlantı geçersiz veya süresi dolmuş olabilir.',
  confirmEmailFailedHint: 'Lütfen bağlantıyı tekrar deneyin veya yeni bir onay e-postası isteyin.',
  invalidConfirmEmailLink: 'Bu onay bağlantısı geçersiz veya eksik.',

  // Document List Extended
  documentListTitle: 'Belge Listesi',
  viewAllDocuments: 'Tüm belgelerinizi görüntüleyin',
  noDocumentsFound: 'Belge Bulunamadı',
  noDocumentsYet: 'Henüz hiç belgeniz yok.',
  pleaseLoginToView: 'Belgelerinizi görmek için lütfen giriş yapın.',
  failedToLoadDocuments: 'Belgeler yüklenemedi. Lütfen tekrar deneyin.',
  title: 'Başlık',
  expirationDate: 'Son Geçerlilik Tarihi',
  status: 'Durum',
  actions: 'İşlemler',
  view: 'Görüntüle',
  operation: 'İşlem',
  unknown: 'Bilinmiyor',
  untitledDocument: 'Başlıksız Belge',
  documentFilters: 'Filtreler',
  signingStatusFilter: 'İmzalama durumu',
  signStatusAll: 'Tümü',
  signStatusSigned: 'Tamamlandı',
  signStatusPending: 'Devam ediyor',
  createdFromFilter: 'Oluşturulma (başlangıç)',
  expiresBeforeFilter: 'Son geçerlilik (bitiş)',
  operationIdFilter: 'İşlem kimliği',
  operationIdFilterPlaceholder: 'İsteğe bağlı işlem kimliği',
  applyFilters: 'Filtreleri uygula',
  resetFilters: 'Sıfırla',
  showFilters: 'Filtreleri göster',
  hideFilters: 'Filtreleri gizle',

  // Profile Extended
  myProfile: 'Profilim',
  viewPersonalInfo: 'Kişisel bilgilerinizi görüntüleyin',
  pleaseLoginToViewProfile: 'Profilinizi görmek için lütfen giriş yapın.',
  failedToLoadProfile: 'Profil yüklenemedi',

  // Footer
  footerText: 'mySign, özenle hazırlandı',
  footerIn: 'Azerbaycan\'da © 2026 -',
  footerCopyright: '© 2026 mySign.az. All rights reserved.',
  privacyPolicy: 'Gizlilik Politikası',
  termsOfService: 'Kullanım Şartları',

  // Upload Document Extended
  review: 'İnceleme',
  signers: 'İmzacılar',
  tinCode: 'VÖEN Kodu',
  selectStorageOrganisation: 'Depolama Kuruluşu Seçin',
  chooseStorageOrganisation: 'Belgenizin yükleneceği depolama kuruluşunu seçin.',
  noOrganisationsAvailable: 'Kullanılabilir kuruluş yok. Lütfen destek ile iletişime geçin.',
  endpoint: 'Endpoint',
  selectDocument: 'Belge Seçin',
  selectDocumentHint: 'Bilgisayarınızdan bir PDF dosyası seçin.',
  selectedFile: 'Seçilen dosya',
  documentSuccessfullyUploaded: 'Belge Başarıyla Yüklendi!',
  thankYouMessage: 'Hizmetimizi kullandığınız için teşekkürler. Belgeniz yüklendi ve imzacılar bilgilendirilecek.',
  goToDocumentList: 'Belge listesine git',
  signingLink: 'İmzalama Bağlantısı',
  signingLinkCopied: 'Bağlantı kopyalandı',
  failedToLoadOrganisations: 'Kuruluşlar yüklenemedi. Lütfen sayfayı yenileyin.',

  // Document Page
  document: 'Belge',
  validityPeriod: 'Geçerlilik Süresi',
  from: 'Başlangıç',
  to: 'Bitiş',
  organisation: 'Kuruluş',
  notAvailable: 'Yok',
  operationId: 'İşlem ID',
  signed: 'İmzalandı',
  pending: 'Beklemede',
  documentStatusDone: 'Tamamlandı',
  documentStatusInProgress: 'Devam ediyor',
  type: 'Tür',
  signingParties: 'İmza Tarafları',
  signingPartyStatusExpired: 'Süresi doldu',
  signingPartyStatusRejected: 'Reddedildi',
  signingPartyStatusReleased: 'Serbest bırakıldı',
  finLabel: 'FIN',
  noDocumentInfo: 'Belge bilgisi mevcut değil',
  signWithSima: 'Sima ile İmzala',
  release: 'Release',
  confirm: 'Onayla',
  releaseDialogMessage: 'Bu belgeyi onaylıyorsunuz (release).',
  rejectDialogMessage: 'Bu belgenin imza talebinden vazgeçiyorsunuz.',
  releaseDialogConfirm: 'Release',
  rejectDialogConfirm: 'Vazgeç',
  failedToUpdateSignStatus: 'İmzalama durumu güncellenemedi. Lütfen tekrar deneyin.',
  reject: 'Reddet',
  documentTabDetails: 'Detaylar',
  documentTabDocument: 'Belge',
  documentTabListLabel: 'Belge bölümleri',
  documentActions: 'İşlemler',
  documentActionsExpand: 'Belge işlemlerini göster',
  documentActionsCollapse: 'Belge işlemlerini gizle',
  documentDetailsResize: 'Belge detayları panelini yeniden boyutlandır',
  documentMoreDetails: 'Daha fazla detay',
  pdfRenderError: 'PDF tarayıcıda görüntülenemedi. Harici olarak açmayı deneyin.',
  openPdfInBrowser: 'Tarayıcıda aç',
  downloadDocument: 'İndir',
  simaSignModalTitle: 'SIMA ile İmzala',
  simaScanQrDesktop: 'SIMA uygulaması ile QR kodu tarayın',
  simaScanQrMobile: 'Veya başka bir cihazda SIMA ile QR kodu tarayın',
  simaOpenSignerApp: 'İmzalama uygulamasını aç',
  simaEnlargeQr: 'QR kodu büyüt',
  simaEnlargedQr: 'Büyütülmüş QR kod',
  simaTapQrToZoom: 'Büyütmek için dokunun',
  simaTapToCloseQr: 'Kapatmak için herhangi bir yere dokunun',
  simaSignWaiting: 'İmza bekleniyor…',
  simaSignThanks: 'Teşekkürler. Belge imzalandı.',
  openDocument: 'Belgeyi Aç',
  closeDocumentViewer: 'Belge Görüntüleyiciyi Kapat',
  openDocumentViewer: 'Belge Görüntüleyiciyi Aç',
  noDocumentLoaded: 'Belge önizlemesi yüklenmedi. Sunucudan almak için dosyayı gösterin.',
  loadDocument: 'Belgeyi Yükle',
  displayFile: 'Dosyayı göster',
  rejectDocument: 'Belgeyi Reddet',
  rejectDocumentReason: 'Lütfen bu belgeyi reddetme nedeninizi belirtin.',
  rejectionReason: 'Reddetme Nedeni',
  documentGUIDNotFound: 'Belge GUID bulunamadı.',
  failedToFetchDocumentInfo: 'Belge bilgisi alınamadı',
  errorFetchingDocumentInfo: 'Belge bilgisi alınırken hata oluştu. Lütfen daha sonra tekrar deneyin.',
  signingLinkAccessDenied: 'Bu imzalama bağlantısına erişiminiz yok. Size gönderilen bağlantıyı açın veya doğru hesapla giriş yapın.',
  failedToFetchDocument: 'Belge alınamadı',
  errorFetchingDocument: 'Belge alınırken hata oluştu. Lütfen daha sonra tekrar deneyin.',
  invalidResponseFormat: 'Geçersiz yanıt formatı',
  failedToInitiateSigning: 'İmzalama işlemi başlatılamadı',
  documentSigningByOther: 'Belge diğer tarafça imzalanıyor. Lütfen 5 dakika sonra tekrar deneyin.',
  errorInitiatingSigning: 'İmzalama işlemi başlatılırken hata oluştu. Lütfen daha sonra tekrar deneyin.',
  signWithUsbToken: 'SIMA USB Anahtarı ile İmzala',
  failedToReadCertificates: 'USB tokendan sertifikalar okunamadı',
  noCertificatesFound: 'Sertifika bulunamadı. Lütfen USB tokeninizi takın.',
  errorReadingCertificates: 'Sertifikalar okunurken hata oluştu. Lütfen USB tokeninizin bağlı olduğundan emin olun.',
  pleaseSelectCertificate: 'Lütfen bir sertifika seçin',
  selectCertificate: 'Belgeyi imzalamak için lütfen bir sertifika seçin',
  documentNotReady: 'Belge bilgisi hazır değil. Lütfen sayfanın yüklenmesini bekleyin, sonra imzalayın.',
  documentNotReadyNoSignerId: 'USB ile imzalamak için bu belgeyi size gönderilen kişisel imzalama bağlantınızla açın. Bu sayfa imzacı ID olmadan açıldı.',
  serialNumber: 'Seri Numarası',
  sign: 'İmzala',
  missingDocumentInfo: 'Belge bilgisi eksik',
  failedToSignDocument: 'Belge imzalanamadı',
  errorSigningDocument: 'Belge imzalanırken hata oluştu',
  failedToUploadSignedDocument: 'İmzalı belge yüklenemedi',
  errorSigningWithUsbToken: 'Belge USB token ile imzalanırken hata oluştu',

  signLinkStatusLabel: 'Durum',
  signLinkStatusPending: 'İmza bekleniyor',
  signLinkStatusReleased: 'Onaylandı (vize)',
  signLinkStatusUnknown: 'Bilinmeyen durum',
  signLinkHello: 'Merhaba,',
  signLinkPageTitleSigner: 'Belgeyi imzalayın',
  signLinkPageTitleVisa: 'Belgeyi onaylayın',
  signLinkValidUntil: 'Geçerlilik',
  signLinkSignedOn: 'Tarih',
  signLinkSignCta: 'Sima ile imzala',
  signLinkVisaCta: 'Onaylamak için giriş yapın',
  signLinkVisaNotice:
    'Bu bir Visa belgesidir. mySign’da açmak ve tek düğmeyle onaylamak için giriş yapın.',
  signLinkViewIntro: 'Belgeyi tarayıcıda görmek için mySign.az üzerinde',
  signLinkLoginAction: 'giriş yapın',
  signLinkViewOr: 'veya',
  signLinkRegisterAction: 'kayıt olun',
  signLinkHowToSignTitle: 'Sima ile nasıl imzalarım?',
  signLinkHowToVisaTitle: 'Nasıl onaylarım?',
  signLinkHowToStep1: 'Düğmeye dokunun ve Sima uygulamasını açın.',
  signLinkHowToStep2: 'İşlemi uygulamada tamamlayın. Bilgisayarda QR kodu tarayın.',
  signLinkHowToStep3: 'Bu sayfa sonucu kendisi gösterecek.',
  signLinkContinueInSima: 'Sima’da devam edin',
  signLinkOpenSima: 'Sima uygulamasını aç',
  signLinkScanOtherDevice: 'Başka cihazda tarayın',
  signLinkQrInstructions: 'QR kodu Sima uygulaması ile tarayın.',
  signLinkQrAlt: 'Sima için QR kod',
  signLinkPolling: 'İmza durumu kontrol ediliyor…',
  signLinkNotFoundTitle: 'Bağlantı bulunamadı',
  signLinkNotFoundBody: 'Bu bağlantı geçersiz veya mevcut değil. Size gönderilen daveti yeniden açın.',
  signLinkInvalidTitle: 'Geçersiz bağlantı',
  signLinkInvalidBody: 'Bu imzalama bağlantısı geçerli değil. Yeni bir davet bağlantısı açın.',
  signLinkLoadError: 'Bilgiler yüklenemedi. Yeniden deneyin.',
  signLinkRetry: 'Yeniden dene',
  signLinkLoading: 'Yükleniyor',
  signLinkPrivacy: 'Gizlilik',
  signLinkFooterNav: 'Bağlantılar',
  signLinkThanks: 'Teşekkürler.',
  signLinkCompletedSigned: 'Belge imzalandı.',
  signLinkCompletedReleased: 'Belge onaylandı.',
  signLinkLockGeneric: 'Belge şu anda kilitli. Biraz sonra yeniden deneyin.',
  signLinkStartError: 'İmzalama başlatılamadı. Yeniden deneyin.',
  signLinkBlockedHint: 'Şu anda imzalama mümkün değil.',
  signLinkAlreadyUsed: 'Bu imzalama bağlantısı zaten kullanıldı.',
};
